<template>
  <div>
    <DashboardHeader title="Finance Switchboard">
      <DashboardTiles :tiles="tiles"></DashboardTiles>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import { mapGetters } from "vuex";
import DashboardHeader from "@/components/DashboardHeader.vue";
import DashboardTiles from "@/components/myLibrary/DashboardTiles.vue";

export default {
  components: {
    DashboardHeader,
    DashboardTiles
  },
  computed: mapGetters([
    "getAccessToken",
    "getUserSchool",
    "getCurrentUser",
    "getThemeColor",
    "getAppName",
    "isManager",
    "isAdmin",
    "isStaff"
  ]),
  data() {
    return {
      tiles: [
        {
          id: 3,
          icon: "mdi-cash-lock-open",
          title: "Accounts",
          description: "",

          route: "financial-accounts",
          param: "",
          alevel: [9, 10, 11, 12, 13, 14, 15],
          buttonText: "Enter"
        },
        {
          id: 3,
          icon: "mdi-cash-lock-open",
          title: "Budgets",
          description: "",

          route: "financial-budgets",
          param: "",
          alevel: [9, 10, 11, 12, 13, 14, 15],
          buttonText: "Enter"
        },
        {
          id: 3,
          icon: "mdi-cash-multiple",
          title: "Expenses",
          description: "",

          route: "finance-expenses",
          param: "",
          alevel: [9, 10, 11, 12, 13, 14, 15],
          buttonText: "Enter"
        },
        {
          id: 2,
          icon: "mdi-chart-areaspline",
          title: "Finance Dashboard",
          description: "",

          route: "finance-dashboard",
          param: "",
          alevel: [9, 10, 11, 12, 13, 14, 15],
          buttonText: "Enter"
        }
        // {
        //   id: 3,
        //   icon: "mdi-school",
        //   title: "E-learning",
        //   description: "",

        //   route: "elearning",
        //   param: "",
        //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        //   buttonText: "Enter"
        // },

        // {
        //   id: 3,
        //   icon: "mdi-office",
        //   title: "Learning Materials",
        //   description: "",

        //   route: "learning-materials",
        //   param: "",
        //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        //   buttonText: "Enter"
        // },
        // {
        //   id: 4,
        //   icon: "mdi-credit-card-marker-outline",
        //   title: "Pay Online",
        //   description: "",

        //   route: "pay-online",
        //   param: "",
        //   alevel: [3, 4, 5, 6, 15],
        //   buttonText: "Enter"
        // },
        // {
        //   id: 8,
        //   icon: "mdi-account-circle",
        //   title: "Student Dashboard",
        //   description: "",

        //   route: "student-profile",
        //   param: "",
        //   alevel: [3, 4, 5, 6],
        //   buttonText: "Enter"
        // },
        // {
        //   id: 1,
        //   icon: "mdi-monitor-dashboard",
        //   title: "School Admin",
        //   description: "",

        //   route: "school-admin-dashboard",
        //   param: "",
        //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        //   buttonText: "Enter"
        // },
        // {
        //   id: 6,
        //   icon: "mdi-sticker-check",
        //   title: "Past Questions",
        //   description: "",

        //   route: "previous-years",
        //   param: "",
        //   alevel: [1, 2, 3, 4, 5, 6],
        //   buttonText: "Enter"
        // },
        // {
        //   id: 7,
        //   icon: "mdi-folder-multiple-image",
        //   title: "School Gallery",
        //   description: "",

        //   route: "school-galleries",
        //   param: "",
        //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        //   buttonText: "Enter"
        // },

        // {
        //   id: 9,
        //   icon: "mdi-cog-outline",
        //   title: "Manage Website",
        //   description: "",

        //   route: "website-dashboard",
        //   param: "",
        //   alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        //   buttonText: "Enter"
        // },
        // {
        //   id: 9,
        //   icon: "mdi-calendar",
        //   title: "Upcoming Events",
        //   description: "",

        //   route: "events-calendar",
        //   param: "",
        //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        //   buttonText: "Enter"
        // },
        // {
        //   id: 9,
        //   icon: "mdi-settings",
        //   title: "Manage Users",
        //   description: "",

        //   route: "manage-users",
        //   param: "",
        //   alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        //   buttonText: "Enter"
        // },
        // {
        //   id: 10,
        //   icon: "mdi-card-account-mail",
        //   title: "Contact Us",
        //   description: "",

        //   route: "",
        //   param: "",
        //   alevel: [1, 2, 3],
        //   buttonText: "Enter"
        // },
        // {
        //   id: 9,
        //   icon: "mdi-account-cash",
        //   title: "Staff & Salaries",
        //   description: "",

        //   route: "manage-staff-and-salaries",
        //   param: "",
        //   alevel: [9, 10, 11, 12, 13, 14, 15],
        //   buttonText: "Enter"
        // },
        // {
        //   id: 10,
        //   icon: "mdi-play",
        //   title: "Video Tutorials",
        //   description: "",
        //   route: "video-tutorials",
        //   param: "",
        //   alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        //   buttonText: "Enter"
        // }
      ]
    };
  },
  methods: {
    setUserEmis() {
      axios
        .postDataWithToken(
          "/auth/get-selected-school",
          { emis: this.getUserSchool.emis },
          this.getAccessToken
        )
        .then(data => {
          if (data == "unauthorized") {
            this.overlay = true;
            this.unauthorized = true;
          } else {
            this.$store.commit("setUserSchool", data.school);
            this.$store.commit("setThemeColor", data.school.primary_bg_color);
            this.$store.commit("setAppName", data.school.schname);
            this.$store.commit("setSiteArticles", data.posts);
            this.$store.commit("setSiteStats", data.stats);
            this.$store.commit("setCurrentUser", data.user);
            this.$store.dispatch("setUserStudents", {
              userId: data.user.id,
              token: this.getAccessToken
            });

            localStorage.setItem("themeColor", data.school.primary_bg_color);
            localStorage.setItem("appName", data.school.schname);
            localStorage.setItem("userSchool", JSON.stringify(data.school));

            this.overlay = false;
          }
        });
    },
    signOut() {
      axios
        .postDataWithToken("/auth/logout", {}, this.getAccessToken)
        .then(response => {
          if (response.loggedOut) {
            this.$store.commit("setAuthenticated", false);
            this.$store.commit("setCurrentUser", {});
            this.$store.commit("setCurrentStudent", {});
            localStorage.clear();
            this.$router.push({ path: "/" });
          }
        });
    }
  }
};
</script>

<style>
.rounded-card {
  border-radius: 30px;
}
</style>
